import React from 'react';

import { withFeatures } from '../features/withFeatures';
import styles from './simple_home_public.module.scss';
import { NewWayContent } from '../presentation/new-way';

export const RawSimpleHomePublic: React.FC = () => {
  return (
    <div className={styles.container}>
      <NewWayContent />
    </div>
  );
};

export const SimpleHomePublic = withFeatures('public-home/uk')(
  RawSimpleHomePublic,
);
